import { Dispatch } from 'redux'

import { resetContributionTags } from 'redux/slices/TextAnalysis'
import { fetchContributions } from 'redux/thunks/TextAnalysis'

export const useResetTags = (
  updatingTagsError: boolean,
  dispatch: Dispatch<any>,
) => {
  dispatch(resetContributionTags())
  if (updatingTagsError) {
    dispatch(fetchContributions())
  }
}
